import { parseRem } from './utils'

export const spacing = {
  stack: {
    /** @property {string} 4px */
    quarck: parseRem(4),
    /** @property {string} 8px */
    nano: parseRem(8),
    /** @property {string} 16px */
    xxxs: parseRem(16),
    /** @property {string} 24px */
    xxs: parseRem(24),
    /** @property {string} 32px */
    xs: parseRem(32),
    /** @property {string} 40px */
    sm: parseRem(40),
    /** @property {string} 48px */
    md: parseRem(48),
    /** @property {string} 56px */
    lg: parseRem(56),
    /** @property {string} 64px */
    xl: parseRem(64),
    /** @property {string} 80px */
    xxl: parseRem(80),
    /** @property {string} 120px */
    xxxl: parseRem(120),
    /** @property {string} 160px */
    huge: parseRem(160),
    /** @property {string} 200px */
    giant: parseRem(200)
  },

  inset: {
    /** @property {string} 4px */
    quarck: parseRem(4),
    /** @property {string} 8px */
    nano: parseRem(8),
    /** @property {string} 16px */
    xs: parseRem(16),
    /** @property {string} 24px */
    sm: parseRem(24),
    /** @property {string} 32px */
    md: parseRem(32),
    /** @property {string} 40px */
    lg: parseRem(40)
  },

  squish: {
    /** @property {string} 4px 8px */
    quarck: `${parseRem(4)} ${parseRem(8)}`,
    /** @property {string} 8px 16px */
    nano: `${parseRem(8)} ${parseRem(16)}`,
    /** @property {string} 16px 24px */
    xs: `${parseRem(16)} ${parseRem(24)}`,
    /** @property {string} 16px 32px */
    sm: `${parseRem(16)} ${parseRem(32)}`
  },

  inline: {
    /** @property {string} 4px */
    quarck: parseRem(4),
    /** @property {string} 8px */
    nano: parseRem(8),
    /** @property {string} 16px */
    xxxs: parseRem(16),
    /** @property {string} 24px */
    xxs: parseRem(24),
    /** @property {string} 32px */
    xs: parseRem(32),
    /** @property {string} 40px */
    sm: parseRem(40),
    /** @property {string} 48px */
    md: parseRem(48),
    /** @property {string} 64px */
    lg: parseRem(64),
    /** @property {string} 80px */
    xl: parseRem(80)
  }
}
